<template>
  <div>
    <Breadcrumb class="p-mb-3" :home="home" :model="breadcrumbItems" />
    <generic-datatable v-if="moduleName" :moduleName="moduleName" :moduleLabel="moduleLabel"></generic-datatable>
  </div>
</template>

<script>
import GenericDatatable from "../../components/GenericDatatable";
import { getters} from "./../../store.js";
import helper from "../../helper";

export default {
  data() {
    return {
      moduleName: null,
      moduleLabel: null,
      home: { icon: "pi pi-home", to: "/" },
      breadcrumbItems: [],
    };
  },
  methods: {
    setBreadcrumb() {
      this.moduleLabel = this.modules.filter(
        (x) => x.name == this.moduleName
      )[0].label;
      this.breadcrumbItems = [];
      this.breadcrumbItems.push({ label: this.moduleLabel });
    },
  },
  computed: {
    ...getters,
  },
  components: {
    "generic-datatable": GenericDatatable,
  },
  watch: {
    $route(to, from) {
      this.moduleName = to.params.module;
      this.setBreadcrumb();
    },
  },
  mounted() {
    this.moduleName = this.$route.params.module;
    this.setBreadcrumb();
  },
};
</script>